const noPhotosProvided = 'No photos to show';
const showPhotoList = 'Show photo list';
const hidePhotoList = 'Hide photo list';

export default {
  noPhotosProvided,
  showPhotoList,
  hidePhotoList,
};
